import React from 'react';
import SvgIcon from 'utils/SvgIcon';

const SecurityIcon = ({ fillColor, hoverFill, style }) => (
  <SvgIcon
    {...{ fillColor, hoverFill, style }}
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3 6V3C3 1.34315 4.34315 0 6 0H10C11.6569 0 13 1.34315 13 3V6H15C15.5523 6 16 6.44772 16 7V15C16 15.5523 15.5523 16 15 16H1C0.447715 16 0 15.5523 0 15V7C0 6.44772 0.447715 6 1 6H3ZM5 3C5 2.44772 5.44772 2 6 2H10C10.5523 2 11 2.44772 11 3V6H5V3ZM9 11.7324C9.5978 11.3866 10 10.7403 10 10C10 8.89543 9.10457 8 8 8C6.89543 8 6 8.89543 6 10C6 10.7403 6.4022 11.3866 7 11.7324V14H9V11.7324Z"
      fill="#7CFADB"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4355_22436"
        x1="17"
        y1="17.5"
        x2="1"
        y2="1"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#7CFADB" />
        <stop offset="1" stop-color="#106550" />
      </linearGradient>
    </defs>
  </SvgIcon>
);

export default SecurityIcon;
